export default function scrollTo(to = 0, duration = 300, element = document.body) {
  if (duration <= 0) return;
  const difference = to - element.scrollTop;
  const perTick = (difference / duration) * 10;

  setTimeout(() => {
    element.scrollTop += perTick;
    if (element.scrollTop === to) {
      return;
    }
    scrollTo(to, duration - 10, element);
  }, 10);
}



// WEBPACK FOOTER //
// ./src/client/lib/scrollTo.js